export default __webpack_public_path__ + "static/media/Montserrat-ExtraBoldItalic.6849a97d.ttf";